/* eslint-disable no-unused-vars */
export const LOAD_REQUESTED = "WORKFLOW_STATUS/LOAD_REQUESTED";
export const LOAD_SUCCESS = "WORKFLOW_STATUS/LOAD_SUCCESS";
export const LOAD_FAIL = "WORKFLOW_STATUS/LOAD_FAIL";

export default (state = {}, { type, data }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        return state;
    }
    case LOAD_SUCCESS: {
        return state;
    }
    case LOAD_FAIL: {
        return state;
    }
    default: return state;
    }
};

export const requestLoadWorkflowStatus = data => ({ type: LOAD_REQUESTED, data });
export const successLoadWorkflowStatus = data => ({ type: LOAD_SUCCESS, data });
export const failLoadWorkflowStatus = data => ({ type: LOAD_FAIL, data });
